import React from 'react';
import * as PropTypes from 'prop-types';
import IconAsset from 'Components/layouts/kiosk/KioskLayout/LayoutComponents/IconAsset';
import {prependDigitalAssetsUrl} from 'Utils/prependDigitalAssetsUrl';

const QuickLink = props => {
    return (
        <div className="item">
            <div
                className="quick-links-item-dummy"
                title={props.quickLink.label}
                onClick={props.onClick}
            >
                <div
                    className="quick-links-item-circle"
                    style={{
                        backgroundColor: props.quickLink.icon.backgroundColor,
                    }}
                >
                    <IconAsset
                        icon={{
                            src: props.searchFilters.length
                                ? prependDigitalAssetsUrl(props.quickLink.icon.iconUrl)
                                : props.quickLink.icon.iconUrl,
                            size: props.size,
                        }}
                        title={props.quickLink.label}
                    />
                </div>
                <div className="quick-links-icon-copy">{props.quickLink.label}</div>
            </div>
        </div>
    );
};

QuickLink.propTypes = {
    searchFilters: PropTypes.array,
    quickLink: PropTypes.object,
    onClick: PropTypes.func,
    size: PropTypes.string,
};

export default QuickLink;
